var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-news" }, [
    _vm._m(0),
    _c("div", { staticClass: "main-wrap" }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.currentList, function(item) {
            return _c("div", { staticClass: "item" }, [
              !_vm.isMobile
                ? _c("div", { staticClass: "col date" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(item.date.split("-")[1]) +
                          "-" +
                          _vm._s(item.date.split("-")[2])
                      )
                    ]),
                    _c("span", [_vm._v(_vm._s(item.date.split("-")[0]))])
                  ])
                : _vm._e(),
              _c("img", {
                staticClass: "col img",
                attrs: { src: "static/images/news/" + item.img }
              }),
              _c("div", { staticClass: "info col" }, [
                _vm.isMobile
                  ? _c(
                      "a",
                      { staticClass: "title", attrs: { href: item.url } },
                      [_vm._v(_vm._s(item.title))]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "title",
                        attrs: { href: item.url, target: "_black" }
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                !_vm.isMobile
                  ? _c("p", { staticClass: "desc" }, [
                      _vm._v(_vm._s(item.desc))
                    ])
                  : _vm._e(),
                _c("p", { staticClass: "source" }, [
                  _c("span", { staticClass: "mobile-source" }, [
                    _vm._v(_vm._s(item.source))
                  ]),
                  _vm.isMobile
                    ? _c("span", { staticClass: "mobile-date" }, [
                        _vm._v(_vm._s(item.date))
                      ])
                    : _vm._e()
                ])
              ])
            ])
          })
        ),
        _c(
          "div",
          { staticClass: "page" },
          [
            _c(
              "span",
              {
                staticClass: "btn-prev",
                class: { disable: !_vm.canPrev },
                on: { click: _vm.handelPrev }
              },
              [_vm._v("<")]
            ),
            _vm._l(_vm.pageCount, function(n) {
              return _c(
                "span",
                {
                  class: { active: n == _vm.currentPage },
                  on: {
                    click: function($event) {
                      _vm.handelPage(n)
                    }
                  }
                },
                [_vm._v(_vm._s(n))]
              )
            }),
            _c(
              "span",
              {
                staticClass: "btn-next",
                class: { disable: !_vm.canNext },
                on: { click: _vm.handelNext }
              },
              [_vm._v(">")]
            )
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("新闻动态")]),
      _c("p", { staticClass: "p2" }, [_vm._v("NEWS")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b2b2df2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b2b2df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/news.vue
// module id = fNd4
// module chunks = 0